import { useSignals } from '@preact/signals-react/runtime'
import clx from 'classnames'
import { useEffect, useRef } from 'react'
import { closeAndReset, isSummaryExpanded, searchInputPlaceholder, searchTerm, theme } from '../../signal/searchbox'
import { CaretLeftIcon, SearchIcon, XIcon } from '../Icons/Icons'
import styles from './SearchInput.module.css'

export function SearchInput() {
  useSignals()
  const inputRef = useRef<HTMLInputElement>(null)
  const variant = theme.value

  useEffect(() => {
    if (inputRef.current != null) {
      inputRef.current.focus()
    }
  }, [])

  function backToSearch() {
    searchTerm.value = null
    isSummaryExpanded.value = false
  }

  if (isSummaryExpanded.value && theme.value === 'primary') {
    return null
  }

  return (
    <div className={clx(styles.searchbox__inputOuterWrapper, styles[`searchbox__inputOuterWrapper--${variant}`])}>
      <button
        type="button"
        onClick={() => {
          closeAndReset()
        }}
        className={styles.searchbox__close}
        aria-label="Close searchbox"
        tabIndex={isSummaryExpanded.value || window.innerWidth < 768 ? 0 : -1}
      >
        <CaretLeftIcon />
      </button>
      <div className={clx(styles.searchbox__inputWrapper, styles[`searchbox__inputWrapper--${theme.value}`])}>
        <SearchIcon />
        <input
          type="search"
          disabled={isSummaryExpanded.value}
          ref={inputRef}
          placeholder={searchInputPlaceholder.value}
          value={searchTerm.value ?? ''}
          className={clx(styles.searchbox__input, {
            [styles.searchbox__input__disabled]: isSummaryExpanded.value
          })}
          onInput={(e: React.FormEvent<HTMLInputElement> & { target: { value: string } }) => {
            const currentValue = e.target.value
            searchTerm.value = currentValue
          }}
          aria-label={searchInputPlaceholder.value}
          aria-controls="search-results"
        />
        <button
          type="button"
          onClick={backToSearch}
          aria-label="Clear search"
          title="Clear search"
          className={styles.searchbox__input__cancel}
        >
          <XIcon />
        </button>
      </div>
    </div>
  )
}
